import user from './user'
import patient from './patient'

export default [
  ...user,
  ...patient
]

